import React from "react";
// import { useEffect } from "react";

import { Link } from "react-router-dom";
import Service from '../../service/Service';
import * as actions from '../Actions';

const service = new Service();

export default function DietPlanArticle({ eleRef, Articledata, tool }) {
    return (
        <div className="card-block">
            <div className="card_container">
                {/* <span className="hide">{eleRef.state.relcountplus = 0, eleRef.state.relcount = 6}</span> */}
                <span className="hide">
                {(() => {
                    eleRef.state.relcountplus = 0;
                    eleRef.state.relcount = 6;
                    return null;
                })()}
                </span>

                {Articledata && Articledata.length > 0 && Articledata.map((articles, index1) =>
                    <div key={index1} className={'diet-plan-card act-sum' + index1} id={'month-card-' + (tool=="bd" ? parseInt(articles['weekNo'])+5 : parseInt(articles['stageId']) + 5)} rel={tool=="bd" ? eleRef.state.relcount:index1}>
                        <span className="B20_42 card_title gtmArt"
                         onClick={(e) => eleRef.viewArticle(
                            tool === "bd" ? articles['weekNo'] : articles['stageId'],
                            articles['articleId'],
                            articles['articleUrl']?.replace(
                              'http://parenting.firstcry.com/wp-content/uploads/',
                              'https://cdn.firstcrycdn.com/'
                            ),
                            articles['viewCount'],
                            articles['likeCount'],
                            articles['articleTitle'],
                            e
                          )}
                          
                         >
                            {articles['articleTitle']}
                        </span>
                        <div className="card-img" onClick={(e) => eleRef.viewArticle(
                            tool === "bd" ? articles['weekNo'] : articles['stageId'],
                            articles['articleId'],
                            articles['articleUrl']?.replace(
                            'http://parenting.firstcry.com/wp-content/uploads/',
                            'https://cdn.firstcrycdn.com/'
                            ),
                            articles['viewCount'],
                            articles['likeCount'],
                            articles['articleTitle'],
                            e
                            )}
                        >
                            {/* {`${articles['articleImage']}`.replace(/\.jpg$/i, ".webp")} */}
                            <img
                                src={
                                    (articles['articleImage'] || 'https://cdn.cdnparenting.com/brainbees/community/preact/public/media/no-image.png')
                                    .replace('http://parenting.firstcry.com/wp-content/uploads/', 'https://cdn.firstcrycdn.com/')
                                    .replace(/\.jpg$/i, '.webp')
                                }
                                alt={articles['articleImage'] ? articles['articleTitle'] : 'No Image Available'}                                
                                title={articles['articleImage'] ? articles['articleTitle'] : 'No Image Available'}
                                className="gtmArt"
                                />

                            {/* <img src={articles['articleImage'].replace('http://parenting.firstcry.com/wp-content/uploads/', 'https://cdn.firstcrycdn.com/').replace(/\.jpg$/i, ".webp")} alt={articles['articleTitle']} title={articles['articleTitle']} className="gtmArt" /> */}
                        </div>
                        <div className="card-text R14_61 more" onClick={(e) => eleRef.viewArticle(
                            tool === "bd" ? articles['weekNo'] : articles['stageId'],
                            articles['articleId'],
                            articles['articleUrl']
                                ?.replace('http://parenting.firstcry.com/wp-content/uploads/', 'https://cdn.firstcrycdn.com/'),
                            articles['viewCount'],
                            articles['likeCount'],
                            articles['articleTitle'],
                            e
                            )}
                        >
                            <span>{articles["articleText"]}</span>
                        </div>
                        <div className="read_more_link" onClick={(e) => eleRef.viewArticle(
                            tool === "bd" ? articles['weekNo'] : articles['stageId'],
                            articles['articleId'],
                            articles['articleUrl']
                                ? articles['articleUrl'].replace(
                                    'http://parenting.firstcry.com/wp-content/uploads/',
                                    'https://cdn.firstcrycdn.com/'
                                )
                                : '', // fallback if articleUrl is null/undefined
                            articles['viewCount'],
                            articles['likeCount'],
                            articles['articleTitle'],
                            e
                            )}
                        >
                            <a href={articles['articleUrl']} className="readmorelink R14_link">Read More</a>
                        </div>
                        <div className="divider-line"></div>
                        <div className="card-actions">
                            <div className="card-views social-actions">
                                <span data-icon-font="$" className="icon M14_42 view-icon">
                                </span>
                                <span className="like-count view_count M14_42">{articles['viewCount']} Views</span>
                            </div>
                            <div className="card-likes social-actions">
                                {articles && articles['isLiked'] > 0 ?
                                    (<span>
                                        <span data-icon-font="&#xe009;" className="icon M14_42 active like-icon"></span>
                                        <span className="like-count M14_42">
                                            <span className="total_likes">
                                                {articles['likeCount']}
                                            </span> Likes</span>
                                    </span>
                                    ) :
                                    (
                                        <span>
                                            <span data-icon-font="&#xe009;" className="icon M14_42 like-icon" onClick={(e) => eleRef.likeArticle(articles['articleId'], articles['stageId'], e, articles['likeCount'], articles['viewCount'], articles['articleTitle'])}>
                                            </span>
                                            <span className="like-count M14_42">
                                                <span className="total_likes">
                                                    {articles['likeCount']}
                                                </span> Likes</span>
                                        </span>
                                    )}

                            </div>
                            {tool=="bd" ?
                            <div className="social-actions">
                                {articles['isBookmarked'] ?
                                    <span className="icon bookmarkicon active" onClick={() => { eleRef.setBookMark(articles['articleId'], 0) }}>
                                        <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/bookmark.png" />
                                    </span>
                                    :
                                    <span className="icon bookmarkicon" onClick={() => { eleRef.setBookMark(articles['articleId'], 1) }}>
                                        <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/unbookmark.png" alt="Unbookmark Icon" title="Unbookmark Icon" />
                                    </span>
                                }
                                <span className="bookmark-count M14_42">{service.intToString(articles['bookmarkCount'])} Bookmarks</span>
                            </div>:null
                            }
                            <div className="card-share right social-actions">
                                <span data-icon-font=")" className="icon M14_42 share-icon" onClick={(e) => eleRef.shareOn(e)}></span>
                                <div className="sharing-options">
                                    <ul className="left">
                                        <li className="whatsapp-share left" onClick={(e) => actions.shareArticle('whatsapp',articles['articleUrl'])}>
                                            <span className="M16_61 social-share" id="whatsapp">
                                                <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/whatsapp.png" className="fetusfacebookimg" alt="Whatsapp Icon" title="Whatsapp Icon" />
                                            </span>
                                        </li>
                                        <li className="facebook-share left" onClick={(e) => actions.shareArticle('facebook',articles['articleUrl'])}>
                                            <span className="M16_61 social-share" id="facebook">
                                                <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/facebook.png" className="facebookimg" alt="Facebook Icon" title="Facebook Icon" />
                                            </span>
                                        </li>
                                        <li className="twitter-share left" onClick={(e) => actions.shareArticle('twitter',articles['articleUrl'])}>
                                            <span className="M16_61 social-share" id="twitter">
                                                <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/twitter.png" className="twitterimg" alt="Twitter Icon" title="Twitter Icon" />
                                            </span>
                                        </li>
                                        <li className="twitter-share left" onClick={(e) => actions.shareArticle('pintrest',articles['articleUrl'])}>
                                            <span className="M16_61 social-share" id="pintrest">
                                                <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/pintrest.png" className="pintrestimg" alt="Pintrest Icon" title="Pintrest Icon" />
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                        </div>
                        <div className="hide">
                        {(() => {
                            eleRef.state.relcountplus++;
                            if (eleRef.state.relcountplus % 4 === 0) {
                            eleRef.state.relcount++;
                            }
                            return null;
                        })()}
                        </div>

                        {/* <div className="hide">
                            {eleRef.state.relcountplus++,
                                eleRef.state.relcountplus % 4 == 0 ? (
                                    eleRef.state.relcount++

                                ) : null
                            }
                        </div> */}
                    </div>
                )}
                <div className="share-overlay"></div>
            </div>

        </div>
    );
}
